export const isList = fieldType =>
  fieldType.kind === "LIST" ||
  (fieldType.kind === "NON_NULL" && fieldType.ofType.kind === "LIST");

export const isNonNull = fieldType => {
  // For lists, indicate whether the `ofType` of each list item is non-null.
  if (isNonNullList(fieldType)) {
    return isNonNull(fieldType.ofType);
  }
  if (isList(fieldType)) {
    return fieldType.ofType.kind === "NON_NULL";
  }
  return fieldType.kind === "NON_NULL";
};

export const isNonNullList = fieldType => {
  // As opposed to the the `ofType` of each list item, indicate whther the root
  // list is non-null.
  return fieldType.kind === "NON_NULL" && fieldType.ofType.kind === "LIST";
};

export const fieldKind = fieldType => fieldValue(fieldType, "kind");

export const fieldName = fieldType => fieldValue(fieldType, "name");

const fieldValue = (fieldType, valueProp) => {
  const field = displayableField(fieldType);
  return field ? field[valueProp] : "";
};

export const fieldUrlPath = fieldType => {
  return `/${fieldKind(fieldType).toLowerCase()}/${fieldName(fieldType)}`;
};

export const displayableField = fieldType => {
  // Drill into lists, non-null fields, etc. to get the entity which we want to
  // display. Presently we do not recurse deeply into list types. Only recurse
  // deeper for a non-null list's `ofType`'s kind. For a list, return the
  // `ofType`.
  const isNonNullList =
    fieldType.kind === "NON_NULL" && fieldType.ofType.kind === "LIST";
  if (isNonNullList) {
    if (!fieldType.ofType) return null;
    return displayableField(fieldType.ofType);
  }
  if (isList(fieldType)) {
    if (!fieldType.ofType) return null;
    return maybeNonNullDisplayableField(fieldType.ofType);
  }
  return maybeNonNullDisplayableField(fieldType);
};

const maybeNonNullDisplayableField = fieldType =>
  fieldType.kind === "NON_NULL" ? fieldType.ofType : fieldType;



// WEBPACK FOOTER //
// ./src/utils/fields.js